import styled from "@emotion/styled";
import { TNoShowListItem } from "../../types";
import NoshowTableHeader from "./header";
import NoShowListItem from "./item";
import UI from "@mile-meeting/mile-ui";
import { useNavigate } from "react-router-dom";
import { NoshowListItemSkeleton } from "uis/NoshowManagement";

const NoshowListTable = ({
  noShowRsvList,
  isCanceling,
  selectedId,
  isLoading = false,
  onHandleCancel,
  onHandleCancelRequest,
  onNavigateDetailInfo,
}: {
  noShowRsvList: TNoShowListItem[];
  isLoading?: boolean;
  onHandleCancel: (id: string) => Promise<void>;
  onHandleCancelRequest: (id: string) => Promise<void>;
  onNavigateDetailInfo: (id: string) => void;
  isCanceling?: boolean;
  selectedId?: string;
}) => {
  const navigate = useNavigate();
  const navigatePolicyPage = () => {
    navigate(`/meeting/${encodeURIComponent("운영/예약 정책 관리")}/노쇼 정책 관리`);
  };

  return (
    <TableContainer>
      <NoshowTableHeader />
      {isLoading && (
        <>
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
          <NoshowListItemSkeleton />
        </>
      )}
      {!isLoading &&
        noShowRsvList.length > 0 &&
        noShowRsvList.map((item, index) => (
          <NoShowListItem
            isCanceling={(isCanceling && item.id === selectedId) ?? false}
            key={index}
            noShowInfo={item}
            onClickCancel={async () => await onHandleCancel(item.instanceId)}
            onClickCancelRequest={async () => await onHandleCancelRequest(item.instanceId)}
            onClickTitle={() => onNavigateDetailInfo(item.instanceId)}
          />
        ))}
      {!isLoading && noShowRsvList.length === 0 && (
        <EmptyContainer>
          <UI.Icon name="removeCircle" size={24} color="var(--alias-color-label-alternative)" />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            조회 가능한 노쇼 예약이 없습니다. 혹은{" "}
            <span
              onClick={navigatePolicyPage}
              style={{
                cursor: "pointer",
                fontWeight: 700,
                color: "var(--alias-color-label-alternative)",
                textDecoration: "underline",
                textUnderlinePosition: "from-font",
              }}
            >
              노쇼 취소 기능 활성화 여부
            </span>
            를 확인해 주세요.
          </UI.Typography>
        </EmptyContainer>
      )}
    </TableContainer>
  );
};

export default NoshowListTable;

const TableContainer = styled.div`
  display: flex;
  min-width: 832px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const EmptyContainer = styled.div`
  display: flex;
  min-width: 832px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  gap: 8px;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;
